import type { TagResponseDto } from '@/api/generated/api'

interface TagCardProps {
  tag: TagResponseDto
}

export function TagCard({ tag }: TagCardProps) {
  return (
    <div className="flex items-center gap-2.5">
      <div
        className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg"
        style={{
          backgroundColor: tag.color ? `${tag.color}20` : '#F3F4F6',
        }}
      >
        <div
          className="h-3 w-3 rounded-full"
          style={{ backgroundColor: tag.color || '#6B7280' }}
        />
      </div>
      <div className="min-w-0 flex-1">
        <h4 className="truncate text-sm font-medium text-foreground">
          {tag.name}
        </h4>
        <p className="truncate text-xs text-muted-foreground">
          {tag.description || 'No description'}
        </p>
      </div>
      <svg
        className="h-4 w-4 flex-shrink-0 text-muted-foreground"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5l7 7-7 7"
        />
      </svg>
    </div>
  )
}
